import React, { useContext } from 'react';
import { Icon, Table, Tooltip } from 'antd';

import { ILineItem } from 'src/apis/Reporting/ChargeHistory';
import { formatPrice } from 'src/utils';
import RefundFormContext from './RefundFormContext';
import styles from './LineItemTable.module.css';
import { REFUND_FIELD_PREFIX } from './RefundForm';
import CurrencyFormInput from '../common/CurrencyFormInput';
import {lineItemRefundSum} from "src/apis/Reporting/ChargeHistory";

const { Column } = Table;

export interface IProps {
  invoiceItems: ILineItem[];
}

/**
 * Creates the description string for the line item, including child company information.
 * Only exported for use in tests.
 */
export const makeLineItemDescription = (item: ILineItem) => {
  const prefix = (item.childCompanyID) ? `${item.childCompanyName} (${item.childCompanyID}) - ` : '';
  return prefix + item.description;
}

/**
 * Displays invoice line items for the Refund Modal.
 */
const LineItemTable: React.FC<IProps> = ({invoiceItems}) => {
  const {currency, form} = useContext(RefundFormContext);

  return <Table className={styles.lineItemTable} dataSource={invoiceItems} pagination={false} rowKey='id'>
    {/* TODO SRSP-42944: update the title of this column per spec */}
    <Column title={'Line Item'} key='description' render={(item: ILineItem) =>
      <label htmlFor={REFUND_FIELD_PREFIX + item.id}>
        {makeLineItemDescription(item)}
      </label>
    }/>
    <Column
      title={<span>
        Original Charge{' '}
        <Tooltip title='The total amount the customer was charged for each line item.'>
          <Icon type='info-circle' theme='filled'/>
        </Tooltip>
        </span>}
      key='originalCharge'
      render={(item: ILineItem) => formatPrice(currency, item.amount - item.amountFromCredit)}
    />
    <Column
      title={<span>
        Refund Amount{' '}
        <Tooltip title='Refund amount cannot exceed initial charge amount.'>
          <Icon type='info-circle' theme='filled'/>
        </Tooltip>
        </span>}
      key='refundAmount'
      render={(item: ILineItem, row) => item.product && item.product.name === "salesTax" ?
        <span /> :
        <CurrencyFormInput
            currency={currency}
            fieldId={REFUND_FIELD_PREFIX + item.id}
            form={form}
            maxAmount={(item.amount - item.amountFromCredit - lineItemRefundSum(item)) / 100}
        />}
    />
    <Column
      title={<span>
        Previously Refunded{' '}
        <Tooltip title='Refund amount cannot exceed initial charge amount.'>
          <Icon type='info-circle' theme='filled'/>
        </Tooltip>
        </span>}
      key='previouslyRefunded'
      render={(item: ILineItem) => formatPrice(currency, lineItemRefundSum(item))}
    />
  </Table>;
};




export default LineItemTable;
